import { NSARouterMakerResult } from "namirasoft-account-react";
import { useParams } from "react-router-dom";
import { BalanceEntities } from "../BalanceEntities";
import { BalanceLayout } from "../BalanceLayout";
import { BalanceRouterProps } from "../BalanceRouterProps";
import { AssetProvider } from "../components/AssetProvider";
import { SummaryStatement } from "../components/SummaryStatement";

interface SummaryListPageProps extends NSARouterMakerResult, BalanceRouterProps { }

function SummaryListPage(props: SummaryListPageProps)
{
	let { asset_id } = useParams();

	return (
		<BalanceLayout {...props}
			action={{
				title: "",
				description: "A comprehensive overview of your finances. Review monthly details, including total additions and deductions, to maintain a clear picture of your balance.",
				menus: {}
			}}
			pages={{
				entity: BalanceEntities.summary(props, asset_id ?? ""),
				ui: {
					action: {
						menus: {
							view_history: false
						}
					}
				},
				list: {
					ui: {
						default_mode: "Statement",
						modes: {
							Statement: {
								show_view: false,
								getChild: (entity) => (
									<AssetProvider
										{...props}
										render={(asset => <SummaryStatement entity={entity} asset={asset} />)}
									/>
								)
							}
						},
						tab_page_view: {
							enabled: true,
							tabs: {
								history: false
							}
						}
					}
				}
			}}
		>
			<></>
		</BalanceLayout>
	);
}

export default SummaryListPage;